import { useState } from "react";
import { useSelector } from "react-redux";
import { loadStripe } from '@stripe/stripe-js';
import {
    CheckoutProvider,
    PaymentElement,
    useCheckout
} from '@stripe/react-stripe-js';

import Button from "../../../components/Button";

import './styles.css'

const stripePromise = loadStripe(process.env.REACT_APP_STRIPE_PUB_KEY);

const CheckoutInner = ({ amount }) => {
    const checkout = useCheckout();
    const [loading, setLoading] = useState(false);

    const handleSubmit = () => {
        setLoading(true);
        checkout.confirm().then((result) => {
            if (result.type === 'error') {
                console.log(result.error);
            }
            setLoading(false);
        })
    }

    const printAmount = (price) => {
        return (Number(price) / 100).toLocaleString('en-US', {
            style: 'currency',
            currency: 'USD',
            minimumFractionDigits: 2,
            maximumFractionDigits: 2
        });
    }

    return (
        <div className="checkout-content">
            <div className="checkout-header">
                <span>PapayIA Credits</span>
                <h1>{printAmount(amount)}</h1>
            </div>
            <PaymentElement options={{ layout: 'accordion' }}/>
            <div className="checkout-footer">
                <Button 
                    label="Pay"
                    loading={loading}
                    onClick={handleSubmit}
                />
            </div>
        </div>
    );
};

const Checkout = () => {
    const payments = useSelector((state) => state.payments);

    if (!payments.clientSecret) {
        return <p>Aguardando clientSecret...</p>;
    }

    return (
        <div className="checkout-container">
            <CheckoutProvider
                stripe={stripePromise}
                options={{
                    fetchClientSecret: async () => payments.clientSecret
                }}
            >
                <CheckoutInner amount={payments.amount} />
            </CheckoutProvider>
        </div>
    );
};

export default Checkout;
